import React, { createContext, useState, useEffect, useCallback, useMemo } from 'react';

// Create the context
export const ClockContext = createContext();

export const ClockProvider = ({ children }) => {
  // State for clock visibility and detached state
  const [showClock, setShowClock] = useState(() => {
    const savedState = localStorage.getItem('persistentClockVisible');
    return savedState ? JSON.parse(savedState) : false;
  });
  
  const [isClockDetached, setIsClockDetached] = useState(() => {
    const savedState = localStorage.getItem('persistentClockDetached');
    return savedState ? JSON.parse(savedState) : false;
  });

  // Update localStorage when state changes
  useEffect(() => {
    localStorage.setItem('persistentClockVisible', JSON.stringify(showClock));
  }, [showClock]);

  useEffect(() => {
    localStorage.setItem('persistentClockDetached', JSON.stringify(isClockDetached));
  }, [isClockDetached]);

  // Handle toggling the clock visibility
  const handleClockToggle = useCallback(() => {
    setShowClock(prevShowClock => {
      if (prevShowClock) {
        setIsClockDetached(false);
        return false;
      }
      setIsClockDetached(true);
      return true;
    });
  }, []);

  // Handle closing the clock
  const handleClockClose = useCallback(() => {
    setShowClock(false);
    setIsClockDetached(false);
  }, []);

  const value = useMemo(() => ({
    showClock,
    setShowClock,
    isClockDetached,
    setIsClockDetached,
    handleClockToggle,
    handleClockClose
  }), [showClock, isClockDetached, handleClockToggle, handleClockClose]);

  return (
    <ClockContext.Provider value={value}>
      {children}
    </ClockContext.Provider>
  );
};

export default ClockProvider; 